/* eslint-disable no-extend-native */
if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function(searchValue, replaceValue) {
        

        // Check if the this value is null or undefined
        if (this == null) {
            throw new TypeError('String.prototype.replaceAll called on null or undefined');
        }

        // If searchValue is a RegExp
        if (searchValue instanceof RegExp) {
            // Check if the RegExp has the global flag
            if (!searchValue.global) {
                throw new TypeError('replaceAll must be called with a global RegExp');
            }
            // Use the RegExp directly with replace
            return String.prototype.replace.call(this, searchValue, replaceValue);
        }

        // If searchValue is not a RegExp, convert it to a string
        const searchString = String(searchValue);

        // Escape special RegExp characters in searchString
        // Special characters: . * + ? ^ $ { } ( ) | [ ] \\
        const escapedSearchString = searchString.replace(/[.*+?^${}()|[\]\\\\]/g, '\\\\$&');

        // Create a new global RegExp
        const globalRegExp = new RegExp(escapedSearchString, 'g');

        // Perform the replacement
        return String.prototype.replace.call(this, globalRegExp, replaceValue);
    };
}

export {}